// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-screen[data-v-cb427e36]{position:fixed;top:0;right:0;bottom:0;left:0;background-size:cover;background-position-x:center;background-position-y:center;transition:opacity .5s ease-in-out;opacity:0;pointer-events:none}.loading-screen.visible[data-v-cb427e36]{opacity:1;pointer-events:all}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
